import { render, staticRenderFns } from "./FrFormIbanInput.vue?vue&type=template&id=77305d9a&"
import script from "./FrFormIbanInput.vue?vue&type=script&lang=js&"
export * from "./FrFormIbanInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports